/* Appointment Copy — printable list for discussing medications at a visit. */
import React from "react";
import { ClipboardList } from "lucide-react";

export const AppointmentCard = ({ profile, qr }) => (
  <div data-testid="appointment-card" className="bg-white border border-[#E5E2DC] rounded-2xl p-6 print:border-0 print:rounded-none">
    <div className="flex items-center justify-between flex-wrap gap-2 mb-4">
      <div>
        <div className="text-[10px] tracking-[0.2em] uppercase font-semibold text-[#2B5339] inline-flex items-center gap-1.5">
          <ClipboardList size={11} /> My appointment copy
        </div>
        <h3 className="med-h2 text-xl font-medium text-[#1C2B23]">
          {profile.name}&apos;s current medications — for my next visit
        </h3>
      </div>
      <div className="flex items-center gap-3">
        <div className="text-[11px] text-[#5C6B62]">
          Date of visit: <span className="inline-block w-28 border-b border-dotted border-[#9AA79E]"></span>
        </div>
        {qr && (
          <div data-testid="appointment-card-qr" className="text-center">
            <img src={qr} alt="QR code — opens this medication card" className="w-14 h-14 mx-auto" />
            <div className="text-[8px] text-[#5C6B62]">Scan to open card</div>
          </div>
        )}
      </div>
    </div>
    <table className="w-full text-[12px]">
      <thead>
        <tr className="text-left text-[10px] uppercase tracking-wider text-[#5C6B62] border-b border-[#E5E2DC]">
          <th className="py-1.5 pr-2">Medication &amp; strength</th>
          <th className="py-1.5 pr-2">How I take it</th>
          <th className="py-1.5 pr-2">Why</th>
          <th className="py-1.5">Questions / changes discussed</th>
        </tr>
      </thead>
      <tbody>
        {profile.meds.map((m) => (
          <tr key={m.id} className="border-b border-[#F0EFEA] align-top">
            <td className="py-2 pr-2 font-medium text-[#1C2B23]">
              {m.generic_name} {m.strength}
              {m.brand_name && <span className="text-[#5C6B62] font-normal"> ({m.brand_name})</span>}
            </td>
            <td className="py-2 pr-2 text-[#1C2B23]">{m.directions || (m.times || []).join(", ") || "—"}</td>
            <td className="py-2 pr-2 text-[#1C2B23]">{m.purpose || "—"}</td>
            <td className="py-2"><div className="border-b border-dotted border-[#9AA79E] h-4"></div></td>
          </tr>
        ))}
      </tbody>
    </table>
    <div className="mt-4 grid sm:grid-cols-2 gap-3 text-[11px] text-[#1C2B23]">
      <div>Allergies / reactions: <span className="inline-block w-40 border-b border-dotted border-[#9AA79E]"></span></div>
      <div>Supplements &amp; over-the-counter: <span className="inline-block w-32 border-b border-dotted border-[#9AA79E]"></span></div>
    </div>
    <p className="text-[10px] text-[#5C6B62] mt-3">
      Bring this list to every appointment and hospital visit. Educational and organizational only.
    </p>
  </div>
);

export default AppointmentCard;
